<template lang="pug">
div
  .flex.flex-wrap
    BriqPriceInput.mr-S.mb-S(
      v-for="segment in productSegments"
      :data-test-id="`segment-pricing-input-${segment.SegmentCode}`"
      :key="segment.SegmentCode"
      :label="segment.SegmentName"
      :step="0.01"
      :allowNegativeValues="true"
      v-model="segment.PriceOffset"
      @input="maybeInitializeActiveSegments"
      :disabled="disabled"
      :currencySymbol="currencySymbol($locale, $currency)"
      @blur="vuelidate.product.ActiveSegments.$touch()"
      )
  .validation-message.mt-S(data-test-id='segment-pricing-error') {{ segmentPricingError }}
</template>

<script>
import { pipe, prop, find, propEq } from 'ramda'
import BriqPriceInput from '@v/components/BriqPriceInput.vue'
import { currencySymbol } from '@/helpers/intlFormatter.js'

export default {
  name: 'SegmentPricing',
  components: { BriqPriceInput },
  props: {
    product: { type: Object, required: true },
    selectedResource: Object,
    resourceSegments: Array,
    disabled: Boolean,
    vuelidate: { type: Object, required: true },
  },
  computed: {
    hasActiveSegments() {
      return this.product.ActiveSegments && this.product.ActiveSegments.length > 0
    },
    productSegments() {
      return this.hasActiveSegments ? this.product.ActiveSegments : this.selectedResourceSegments
    },
    activeSegments() {
      return this.product.ActiveSegments
    },
    segmentPricingError() {
      return this.vuelidate.product?.ActiveSegments?.$error
        ? 'Segment pricing is only available with price per person'
        : ''
    },
    selectedResourceSegments() {
      return pipe(
        find(propEq('ResourceKey', this.selectedResource.Key)),
        prop('Segments'),
      )(this.resourceSegments)
    },
  },
  methods: {
    currencySymbol,
    maybeInitializeActiveSegments(v) {
      const initializeActiveSegments = () =>
        (this.product.ActiveSegments = this.selectedResourceSegments)
      if (!this.hasActiveSegments && v !== null) initializeActiveSegments()
    },
  },
}
</script>
